module.exports = __webpack_public_path__ + "static/media/white-logo.62849f44.svg";